import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

class SectionItemAddItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textValue: "",
    };
  }

  handleOnButtonClick = () => {
    const { textValue } = this.state;
    const { item, column, onPropChange } = this.props;
    const items = item[column.accessor] || [];

    if(column.isReadonly){
      return;
    }

    if (onPropChange && textValue) {
      onPropChange({ [column.accessor]: items.concat([{key: items.length, value: textValue}]) });
      this.setState({ textValue: '' });
    }
  };

  handleOnChange = val => {
    const { column } = this.props;
    if(column.irReadonly){
      return
    }

    this.setState({ textValue: val })
  }

  render() {
    const { textValue } = this.state;
    const { t, item, column } = this.props;

    return (
      <div
        key={`sectionItemAddItem-${column.accessor}`}
        className={classNames("sectionItemAddItem")}
      >
        <ColumnTitleWithIcon column={column} item={item}/>
        <div className={classNames("sectionItemAddItemContainer")}>
          <input value={textValue} onChange={({target}) => this.handleOnChange(target.value)}/>
          <div
            className={classNames("sectionItemSelectButton", "btn", "denied")}
            onClick={this.handleOnButtonClick}
          >
            {t("basic.ADD_BUTTON")}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SectionItemAddItem);
